import * as XLSX from 'xlsx';

export const TERMINAL_PHARMACY_TEMPLATE_FILENAME = '담당자_거래처_일괄등록_양식.xls';
export const TERMINAL_PHARMACY_TEMPLATE_HEADERS = [
  '담당자', '담당자ID', '거래처코드', '거래처명', '사업자등록번호', '대표자명', '연락처',
];

export function createTerminalPharmacyTemplate() {
  // Header-only template: sample accounts must never become import data.
  const worksheet = XLSX.utils.aoa_to_sheet([TERMINAL_PHARMACY_TEMPLATE_HEADERS]);
  worksheet['!cols'] = [16, 18, 16, 24, 18, 14, 18].map(wch => ({ wch }));
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, '일괄등록 양식');
  return workbook;
}

export function downloadTerminalPharmacyTemplate() {
  // This importer accepts legacy .xls, not .xlsx.
  XLSX.writeFile(createTerminalPharmacyTemplate(), TERMINAL_PHARMACY_TEMPLATE_FILENAME, { bookType: 'biff8' });
}
